import { useOrderProductsContext } from '@app/components/orders/OrderProducts/OrderProductsContext';

import { OrderStockTypeGroup } from './OrderStockTypeGroup';

export const OrderProductsByStockType = () => {
  const { stockTypeGroupsToDisplay } = useOrderProductsContext();

  return (
    <div className="space-y-10">
      {stockTypeGroupsToDisplay.map(group => (
        <OrderStockTypeGroup group={group} key={group.type} />
      ))}
    </div>
  );
};
